// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"308":"850cbb5b","814":"bcae2424","859":"4a157967"}[chunkId] + ".chunk.js";
};